import React, { useState, useEffect } from 'react';
import { string, shape } from 'prop-types';

import RadioGroup from './RadioGroup';

import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './colorList.module.css';

import Dialog from '../components/Dialog';
import RichContent from '../components/RichContent';

const defaultOption = {
    label: _('Select an option'),
    value: '',
    key: ''
};

/**
 * MontageItems
 *
 * @typedef MontageItems
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that displays a configurator
 */
const MontageItems = props => {
    const { items, onChange, info, sectionDisabled } = props;

    if (!items.length) {
        return null;
    }

    const classes = useStyle(defaultClasses, props.classes);

    const [isInfoOpen, setIsInfoOpen] = useState(false);

    const showInfo = e => {
        e.preventDefault && e.preventDefault();
        setIsInfoOpen(true);
    };

    const hideInfo = e => {
        e.preventDefault && e.preventDefault();
        setIsInfoOpen(false);
    };

    const montageItems = items.map(item => {
        /*
         if (item.default && !item.items.find(item => item.key == '')) {
         item.items.unshift(defaultOption);
         }
         */
        const {
            items: montageItems,
            key,
            label,
            size_matrix,
            default: montageDefault
        } = item;

        montageItems.forEach(item => {
            if (!item.value) {
                item.value = item.key;
            }

            if (!item.code) {
                item.code = item.key;
            }

            /*
            if (item.price) {
                item.label += ` (${item.price} €)`;
            }*/
        });

        return (
            <div className={classes.itemcontrol} key={key}>
                <h2>{label}</h2>
                <div className={classes.cajaresults}>
                    <RadioGroup
                        items={montageItems}
                        field={key}
                        initialValue={montageDefault || montageItems[0].key}
                        disabled={!!size_matrix}
                        radioGroupName={key}
                        onChange={e => {
                            onChange(e.target.value, key);
                        }}
                    />
                </div>
            </div>
        );
    });

    return (
        <fieldset className={classes.section} disabled={sectionDisabled}>
            <legend>
                {_('Elige montaje')}
                {info ? (
                    <span
                        onClick={showInfo}
                        className={classes.info}
                        title={_('Instrucciones de montaje')}
                    >
                        👁 {_('Read')} {_('Instrucciones de montaje')}
                    </span>
                ) : null}
            </legend>
            <div className={classes.itemscontrol}>{montageItems}</div>
            {info ? (
                <Dialog
                    isOpen={isInfoOpen}
                    onConfirm={hideInfo}
                    onCancel={hideInfo}
                    showCancelButton={false}
                    confirmText={_('Close')}
                    title={info.title}
                >
                    <RichContent html={info.text} />
                </Dialog>
            ) : null}
        </fieldset>
    );
};
/*
 MontageItems.propTypes = {
 clases: shape({
 root: string,
 icon: string
 }),
 title: string,
 text: string,
 buttonTitle: string,
 buttonText: string
 };

 MontageItems.defaultProps = {
 buttonTitle: _('Share this element'),
 buttonText: _('Share this!'),
 };
 */
export default MontageItems;
